<template>
    <th
        :class="[
            'px-4 py-3 text-xs font-semibold uppercase tracking-wide text-gray-500',
            alignClass,
            sortable ? 'cursor-pointer select-none hover:text-gray-700' : '',
        ]"
        @click="onClick"
    >
        <span class="inline-flex items-center gap-1" :class="justifyClass">
            <slot>{{ label }}</slot>
            <span v-if="sortable" class="shrink-0">
                <ChevronUpIcon
                    v-if="isActive && dir === 'asc'"
                    class="h-3 w-3 text-indigo-500"
                />
                <ChevronDownIcon
                    v-else-if="isActive && dir === 'desc'"
                    class="h-3 w-3 text-indigo-500"
                />
                <ChevronUpDownIcon v-else class="h-3 w-3 text-gray-300" />
            </span>
        </span>
    </th>
</template>

<script lang="ts" setup>
import { computed, inject } from "vue";
import {
    ChevronUpIcon,
    ChevronDownIcon,
    ChevronUpDownIcon,
} from "@heroicons/vue/24/outline";
import { DA_SORT_KEY, type SortDir } from "./tableSort";

const props = withDefaults(
    defineProps<{
        label?: string;
        field?: string | null;
        align?: "left" | "center" | "right";
    }>(),
    {
        label: "",
        field: null,
        align: "left",
    },
);

const sort = inject(DA_SORT_KEY, null);

const sortable = computed((): boolean => props.field !== null && sort !== null);
const isActive = computed(
    (): boolean => sortable.value && sort?.field.value === props.field,
);
const dir = computed((): SortDir => sort?.dir.value ?? "asc");

const alignClass = computed((): string => {
    if (props.align === "right") return "text-right";
    if (props.align === "center") return "text-center";
    return "text-left";
});
const justifyClass = computed((): string => {
    if (props.align === "right") return "justify-end";
    if (props.align === "center") return "justify-center";
    return "justify-start";
});

const onClick = (): void => {
    if (props.field !== null && sort !== null) {
        sort.toggle(props.field);
    }
};
</script>
